import React from "react";


export const ButtonBack = props => <button
  className="btn btn-faded"
  onClick={props.prevStep}>  {props.title}{" "}
</button>
